module.exports = __webpack_public_path__ + "static/media/img119.dde283b1.jpg";